// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2rNHM","alertIcon":"ConfirmModal_alertIcon__38HoD"};